import React, { useEffect } from 'react';
import { dispatch } from '../redux';

const useSlug = slug =>
    useEffect(() => {
        dispatch('page/get-by-slug', slug);
    }, [slug]);

export default useSlug;
